import * as React from 'react';
import { VPage, Page, Scroller } from "tonva-react";
import { CPointProduct } from './CPointProduct';
import { List } from "tonva-react";
import { observer } from 'mobx-react-lite';
import { renderPointRecord } from './VMyPoint';
import { RevenueExpenditure } from './basicRefer';

export class VRevenueExpenditure extends VPage<CPointProduct> {
    private showList: any = [];
    private tipNone: string = '『 无 』';
    async open(param?: any) {
        this.matchData(param);
        this.openPage(this.page, { header: param });
    }

    private matchData = (header: string) => {
        let { pagePointHistory, cApp } = this.controller;
        let { POINTHISTORY, SIGNINHISTORY } = RevenueExpenditure;
        switch (header) {
            case POINTHISTORY:
                this.showList = pagePointHistory;
                this.tipNone = '『 未曾拥有过 不曾失去过 』';
                return;
            case SIGNINHISTORY:
                this.showList = cApp.cSignIn.signinPageHistory;
                this.tipNone = '『 从未得到过 开启首签之旅 』';
                return;
            default:
                return;
        }
    }

    protected onScrollBottom = async (scroller: Scroller) => {
        this.showList.more();
    }

    private page = observer((param: any): any => {
        let { header } = param;
        // this.matchData(header);
        let none = <div className="mt-4 text-secondary d-flex justify-content-center">{this.tipNone}</div>;

        return <Page header={header} onScrollBottom={this.onScrollBottom}>
            <List items={this.showList} item={{ render: renderPointRecord }} none={none} />
        </Page>;
    });
}
